import React, { useContext } from 'react';
import BookerShortContext from '../../context/bookerShortContext';
import '../../assets/styles/cancel-ride.sass';
import BookerContext from '../../context/bookerContext';

const CancelRide = () => {
  const { state: { step, isWebBooker } = {} } = useContext(BookerContext);
  const { togglePopup, cancelRide } = useContext(BookerShortContext);

  const isUpcomingRideInfoStep = (isWebBooker && step === 13) || (!isWebBooker && step === 10);

  const openCancelRidePopup = () => {
    const cancelRideBtn = [
      {
        isSecondary: true,
        textBtn: 'DON’T CANCEL',
      },
      {
        clickHandler: cancelRide,
        textBtn: 'CANCEL RIDE',
      },
    ];
    togglePopup(true, 'cancelRide', cancelRideBtn);
  };

  return (
    <div
      className={`cancel-ride-btn ${isUpcomingRideInfoStep && 'cancel-ride-btn-upcoming'}`}
      onClick={openCancelRidePopup}
    >
      {isUpcomingRideInfoStep ? 'Cancel this upcoming ride ' : 'Cancel Ride'}
    </div>
  );
};

export default CancelRide;
